import { lazy } from "react";
import { Navigate } from "react-router";
import Loadable from "src/routes/Loadable";

const Update = Loadable(
  lazy(() => import("src/pages/admin/pv/update/index"))
);
const History = Loadable(lazy(() => import("src/pages/admin/pv/history/index")));

const pv = [
  {
    path: "pv",
    children: [
      { element: <Navigate to="update" />, index: true },
      { path: "update", element: <Update /> },
      { path: "history", element: <History /> },
    ],
  },
];

export default pv;
